import React from "react";
import { Card, CardHeader, CardBody, CardFooter, Button, ListGroup, ListGroupItem } from "reactstrap";
import { FaTrash, FaPen } from "react-icons/fa";

const stringUtil = require("../../../../utils/string/stringUtil");
const dateUtil = require("../../../../utils/dateUtil/dateUtil");
const menuSnoozeUtil = require("../menuSnoozeUtil");
const translator = require("../../../../utils/translator/translator");

function SnoozesContainer(
    {
        snoozes,
        selectedMenu,
        onEditSnooze,
        onDeleteSnooze
    }
)
{
    const snoozeCards = [];
    Object.keys(snoozes).forEach(snoozePrimaryId =>
    {
        const snooze = snoozes[snoozePrimaryId];
        if (snooze.menus.includes(selectedMenu.id) && menuSnoozeUtil.isSnoozed(snooze)) 
        {
            const dispatchTypes = (Array.isArray(snooze.dispatchTypes) && snooze.dispatchTypes.length > 0) ? snooze.dispatchTypes.join(', ') : "ALL";
            const venueCodes = (Array.isArray(snooze.venueCodes) && snooze.venueCodes.length > 0) ? snooze.venueCodes.join(', ') : "ALL";
            const operator = snooze.operator;
            const expiry = stringUtil.areStringSame("-1", snooze.expiry) ? "Manual" : dateUtil.formatDate(dateUtil.convertToLocalStandard(snooze.expiry), "HH:mm, ddd, DD/MM/YYYY");
            const description = menuSnoozeUtil.getSnoozeDescription(selectedMenu, snooze);
            const body = (
                <Card key={snoozePrimaryId} className="mb-3">
                    <CardHeader style={{ fontWeight: "500" }}>{description.type} - {description.caption}</CardHeader>
                    <ListGroup key={snoozePrimaryId} flush>
                        <ListGroupItem>
                            <div className="d-flex justify-content-between">
                                <div>{translator.getLabel("snoozed_till")}</div>
                                <div>{expiry}</div>
                            </div>
                        </ListGroupItem>
                        <ListGroupItem>
                            <div className="d-flex justify-content-between">
                                <div>{translator.getLabel("dispatch_types")}</div>
                                <div>{dispatchTypes}</div>
                            </div>
                        </ListGroupItem>
                        <ListGroupItem>
                            <div className="d-flex justify-content-between">
                                <div>{translator.getLabel("venues")}</div>
                                <div>{venueCodes}</div>
                            </div>
                        </ListGroupItem>
                        <ListGroupItem>
                            <div className="d-flex justify-content-between">
                                <div>{translator.getLabel("operator")}</div>
                                <div>{operator}</div>
                            </div>
                        </ListGroupItem>
                    </ListGroup>
                    <CardFooter>
                        <div className="d-flex justify-content-between">
                            <Button style={{ background: "var(--colors-white)" }} className="btn-action" onClick={() => onEditSnooze(snooze)}>
                                <FaPen />
                            </Button>
                            <Button className="btn-action" style={{ color: "var(--colors-red)", borderColor: "var(--colors-red)", background: "var(--colors-white)" }} onClick={() => onDeleteSnooze(snooze)}>
                                <FaTrash />
                            </Button>
                        </div>
                    </CardFooter>
                </Card>
            )
            snoozeCards.push(body);
        }

    });

    return (
        <Card style={{height: "85vh"}}>
            <CardHeader>{translator.getLabel("snoozes")}</CardHeader>
            <CardBody style={{ overflow: "auto" }}>
                {
                    snoozeCards.length
                        ? snoozeCards
                        : <div className="d-flex h-100 justify-content-center align-items-center">
                            <h5 style={{color: "var(--colors-text-light)"}}>{translator.getLabel("no_items_snoozed_in_this_menu")}</h5>
                        </div>
                }
            </CardBody>
        </Card>
    )
}

export default SnoozesContainer;